import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentOptionPage } from './payment-option.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentOptionPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class PaymentOptionPageRoutingModule {}
